import React, { useState } from 'react'
import { Link } from 'gatsby'

import './index.scss'
import { ThemeSwitch } from '../theme-switch'
import { GnbBtn } from '../gnb/btn'
import { Gnb } from '../gnb'

export const Header = ({ title, location, rootPath, selectCategory }) => {
  const [gnbState, setGnbState] = useState('close')
  const [motionState, setMotionState] = useState(false)
  const isRoot = location.pathname === rootPath

  return (
    isRoot && (
      <header className="header-wrapper">
        <div className="header-inner">
          <h1 className="home-header">
            <Link to={`/`} className="link">
              {title}
            </Link>
          </h1>

          {<ThemeSwitch />}
          {
            <GnbBtn
              setGnbState={setGnbState}
              gnbState={gnbState}
              setMotionState={setMotionState}
            />
          }
        </div>
        {gnbState === 'open' && (
          <Gnb
            selectCategory={selectCategory}
            motionState={motionState}
            gnbState={gnbState}
            setGnbState={setGnbState}
            setMotionState={setMotionState}
          />
        )}
      </header>
    )
  )
}
